import { Link } from 'react-router-dom';
import { Reveal } from './Reveal.tsx';
import type { SiteConfig } from '../../siteContentTypes.ts';

export function FinalCta({ config }: { config: SiteConfig }) {
  const { finalCta } = config;

  return (
    <section style={{ padding: '24px 24px 64px', maxWidth: 1160, margin: '0 auto' }}>
      <Reveal>
        <div
          style={{
            borderRadius: 28,
            padding: '64px 32px',
            textAlign: 'center',
            background: 'linear-gradient(135deg, var(--accent), var(--accent-dark))',
            color: '#fff',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <div
            style={{
              position: 'absolute',
              inset: 0,
              backgroundImage: 'radial-gradient(circle at 20% 20%, rgba(255,255,255,0.12), transparent 40%), radial-gradient(circle at 80% 80%, rgba(255,255,255,0.1), transparent 40%)',
            }}
          />
          <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', gap: 16, alignItems: 'center' }}>
            <h2 style={{ fontSize: 32, fontWeight: 800, margin: 0, maxWidth: 560 }}>{finalCta.title}</h2>
            <p style={{ fontSize: 16, margin: 0, opacity: 0.92, maxWidth: 480 }}>{finalCta.subtitle}</p>
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', justifyContent: 'center', marginTop: 8 }}>
              <Link
                to={finalCta.ctaPrimaryUrl}
                className="btn"
                style={{ width: 'auto', padding: '14px 26px', background: '#fff', color: 'var(--accent-dark)' }}
              >
                {finalCta.ctaPrimaryText}
              </Link>
              <Link
                to={finalCta.ctaSecondaryUrl}
                className="btn"
                style={{ width: 'auto', padding: '14px 26px', background: 'rgba(255,255,255,0.15)', color: '#fff', border: '1px solid rgba(255,255,255,0.4)' }}
              >
                {finalCta.ctaSecondaryText}
              </Link>
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
